export const Perfil = {
    GERENTE_OPERACIONAL: 'Gerente Operacional',
    USUARIO_EXTERNO: 'Usuario Externo',
    TECNICO: 'Técnico',
    ADMINISTRADOR_ANALISE: 'Administrador de Análise',
    PUBLICO: 'Público',
    SEMIL: 'Semil Consulta'
};